// extracted by mini-css-extract-plugin
module.exports = {"description":"Contact_description__25Q38","descriptionLink":"Contact_descriptionLink__33vBI","action":"Contact_action__3lN3I","contactDetail":"Contact_contactDetail__2urMS"};